module.exports = __webpack_public_path__ + "static/media/GrP.42046d55.jpg";